<template lang="pug">
include /../../s-pug/mixin-icon
include /../../s-pug/mixin-profileShared--sectionHeading
include /../../s-pug/mixin-profileShared--overview
include /../../s-pug/mixin-profileShared--benefits
include /../../s-pug/mixin-profileShared--openings
include /../../s-pug/mixin-profileShared--qaPrimary
include /../../s-pug/mixin-profileShared--locationAndTimezone
include /pug/mixin-profileEdit--sectionEdit
include /pug/mixin-profileEdit--openingListItem
include /pug/mixin-profileEdit--benefitListItem
//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
Layout(v-if="profileSrc && profileDraft")
   Panel(v-if="showPanel" :panelProps="{...panelProps}" @cancel="profilePanelCancel" @done="profilePanelDone" :showJobViewerHandler="showJobViewerHandler")
   JobViewer(v-if="isJobViewerOpen" :opening="jobViewerOpening" :company="profileSrc.companyResolved.data" :isPreviewMode="isJobViewerInPreviewMode" @previewClose="jobViewerPreviewClose")
   .Underlay._alpha-80._radius._cursor-default(v-if="rootLevelImageUploadUiRef && !isSavingDraft" ref="underlayForImageUploadUi")
   .Profile-layout
      //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      //- Image Upload UI
      //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      ._absoluteCenterXY._bg-white._radius._boxShadow2._px1._py075._borderDefault._mx-auto._cursor-default._w100(
         :style="{'z-index': '500', 'max-width': rootLevelImageUploadUiRef === 'ref-imageLogo' ? '600px' : '1200px'}"
         v-if="rootLevelImageUploadUiRef && !isSavingDraft"
      )
         ._mb05._fs-3._bold {{imageUploadUiHeading}}
         ._mb1-5._c-grey-600._fs-075 {{imageUploadUiHelpText}}
         ._mb2
            ._px2._py7._relative._t-center
               ._stretch._radius._border._borderColor-grey-100._border-width2(v-bind:class="dropZoneActive ? '_borderColor-blue-300 _z100' : '_border--dashed'" @drop.prevent="rootLevelImageOnUpload" @dragenter.prevent="dropZoneActive = true" @dragleave.prevent="dropZoneActive = false" @dragover.prevent)
               ._absoluteCenterXY
                  ._mb1._c-grey-500 Drag image
                  label._mx-auto
                     .Btn.Btn--white.Btn--sm._fs-075 Choose image
                     input._alpha-0(style="width: 0; height: 0;" type="file" v-on:change="rootLevelImageOnUpload($event)" accept=".png, .jpg, .jpeg") 
         ._flex
            button.Btn.Btn--sm.Btn--greyDk._ml-auto(type="button" @click="cancelRootLevelImageUploadUi()") Cancel
      //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      //- Cover image
      //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      ._relative._showOnParentHover-parent
         Loading(v-if="isSavingDraft && rootLevelImageUploadUiRef === 'ref-imageHero'")
         .Profile-heroImageContainer._bg-grey-200(:style="{'background-image': profileDraft.imageHero && profileDraft.imageHero.src && `url( ${createImagePath({src: profileDraft.imageHero.src})} )`}")
         //- Change image
         ._absolute._r0._t0._pr1._pt1(v-if="profileDraft.imageHero && profileDraft.imageHero.src")
            button.Btn.Btn--xs.Btn--white(@click="rootLevelImageUploadUiShow({ref: 'ref-imageHero', heading: 'Cover image', helpText: 'JPG or PNG. Upload the largest version possible. Ideally at least <code>5760 x 1200 px</code>.'})" v-bind:disabled="editingPanel.ref") Change image
         //- Upload (first) image
         ._stretch._cursor-pointer(v-if="!profileDraft.imageHero || !profileDraft.imageHero.src" @click="rootLevelImageUploadUiShow({ref: 'ref-imageHero', heading: 'Cover image', helpText: 'JPG or PNG. Upload the largest version possible. Ideally at least <code>5760 x 1200 px</code>.'})")
            ._absoluteCenterXY
               ._c-grey-500._bold Click to upload a cover image
      .Profile-layoutMain
         //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
         //- Publish UI
         //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
         .PublishUi._flex._flex._flexDirection-column._flex-alignItemsFlexEnd
            ._t-right(v-tippy="{placement: 'left', onShow: () => !profileHasUnpublishedEdits}" content=`The auto-save status of changes`)
               ._bg-white._relative._overflowHidden._radius-50(style="width: 70px; height: 70px;" v-bind:class="!profileHasUnpublishedEdits ? '_alpha-40' : ''" v-tippy="{placement: 'left', onShow: () => profileHasUnpublishedEdits}" content=`All draft changes saved`)
                  .PublishUi-saveIcon(v-if="!isSavingDraft && !editingPanelHasUnsavedEdits && !isPublishing")
                     +icon({name: 'icon-check'})
                  ._absoluteCenterXY(v-if="!isSavingDraft && editingPanelHasUnsavedEdits && !isPublishing" style="width: 80%; height: 80%")
                     +icon({name: 'icon-edit', size:"16px"})
                  Loading(v-if="isSavingDraft || isPublishing" width="90%" height="90%")
            //- ._mt075(v-tippy="{placement: 'left', onShow: () => !profileHasUnpublishedEdits || editingPanel.ref}" :content="editingPanel.ref ? `First submit or cancel the panel you're editing` : `Complete all profile sections before publishing`")
            ._mt075(v-if="profileHasUnpublishedEdits" v-tippy="{placement: 'left', onShow: () => !profileHasUnpublishedEdits || editingPanel.ref}" :content="editingPanel.ref ? `First submit or cancel the panel you're editing` : `Edits do not go live until you've published them. Note: it may take several minutes after publishing to see the change live.`")
               button.Btn.Btn--yellow(v-bind:disabled="!profileHasUnpublishedEdits || editingPanel.ref" @click="publishEdits()") Publish
            //- ._mt05(v-tippy="{placement: 'left', onShow: () => !profileHasUnpublishedEdits || editingPanel.ref}" :content="editingPanel.ref ? `First submit or cancel the panel you're editing` : `You don't yet have any edits`")
               //- TODO: guard this action with a confirm dialog/request (perhaps inline or just below it (or something)?)
               //- button.Btn.Btn--white._fs-05.Btn--sm(v-bind:disabled="!profileHasUnpublishedEdits || editingPanel.ref" type="button" @click="resetAllProfileEdits()" v-tippy="{placement: 'left'}" content=`This resets all non-published changes`) Reset
         //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
         //- Main
         //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
         .Profile.Layout-container._relative
            #js-layoutMain.Layout-main._lineHeight
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               //- Overview
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               #overview.Profile-sectionWrap.Profile-sectionWrap--overview._relative(
                  ref="ref-overview" 
                  v-bind:class="{'is-editingPanel': editingPanel.ref === 'ref-overview'}"
               )
                  Loading(v-if="editingPanel.ref === 'ref-overview' && editingPanel.loading")
                  +profileShared-overview({context: 'vue'})
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               //- Openings
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               hr._mb2._bg-grey-100
               #openings.Profile-sectionWrap._relative._mb2._pb1(
                  ref="ref-openings" 
                  v-bind:class="{'is-editingPanel': editingPanel.ref === 'ref-openings', 'is-editingPanelChild': !!editingPanel.editingChildRef, 'is-childBeingDragged': isDragging === 'openings'}"
               )
                  +profileShared-sectionHeading({context: 'vue', sectionAttr: 'openings', showEditBtnWhenEmpty: false, heading: 'Openings'})

                  Loading(v-if="editingPanel.ref === 'ref-openings' && editingPanel.loading")
                  //- EDIT
                  ._w100(v-if="editingPanel.ref === 'ref-openings'")
                     //- Edit : NEW 
                     ProfileEditNewItemBtn(noun='opening' @onClick="profilePanelNew({type: 'opening', items: profileEditing.openings})")
                     //- Edit : List
                     SlickList(
                        lockAxis="y" 
                        v-model="profileEditing.openings"
                        helperClass="is-dragging"
                        @sort-start="onDragStart('openings')"
                        @sort-end="onDragEnd"
                        @input="onDragSortFinish"
                     )
                        SlickItem.ProfileEdit-openingsItem.ProfileEdit-openingsItem--editView._whenDisabled-noEvents._bg-white._px1-5._py05(
                           class="_borderBottom-noneLast:last-of-type"
                           v-for="(opening, index) in profileEditing.openings" 
                           :index="index"
                           :key="opening.id"
                        )
                           ._relative
                              //- Edit Actions
                              .ProfileEdit-openingsItemEditActions.BtnGroup
                                 button.Btn.Btn--inBtnGroup.Btn--xs.Btn--grey(@click="profilePanelEdit({type: 'opening', itemIndex: index, item: opening, items: profileEditing.openings})") Edit
                                 button.Btn.Btn--inBtnGroup.Btn--xs.Btn--grey(@click="profileSectionChildDelete(index)") Remove
                           .Profile-openingListItem.Profile-openingListItem--editMode(@click.prevent.stop="profilePanelEdit({type: 'opening', itemIndex: index, item: opening, items: profileEditing.openings})")
                              +profileEdit-openingListItem()
                  //- READ
                  div(v-else)
                     div(v-if="!profileDraft.openings || !profileDraft.openings.length")
                        ProfileEditNewItemBtn(noun='opening' @onClick="profilePanelNew({type: 'opening', items: profileDraft.openings, parentPanelToEnter: 'ref-openings', initialUI: true})")
                     +profileShared-openings({context: 'vue', profileObj: profileDraft})
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               //- Q&A - Primary - Multiple Choice (required)
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               hr._mb2._bg-grey-100
               #qaRequired.Profile-sectionWrap(ref="ref-qaPrimary")
                  Loading(v-if="editingPanel.ref === 'ref-qaPrimary' && editingPanel.loading")
                  +profileShared-qaPrimary({context: 'vue', profileObj: profileDraft})
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               //- Benefits
               //- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
               hr._mb2._bg-grey-100
               #benefits.Profile-sectionWrap._relative._pb1-5(
                  ref="ref-benefits" 
                  v-bind:class="{'is-editingPanel': editingPanel.ref === 'ref-benefits', 'is-editingPanelChild': !!editingPanel.editingChildRef, 'is-childBeingDragged': isDragging === 'benefits'}"
               )
                  +profileShared-sectionHeading({context: 'vue', heading: 'Benefits', sectionAttr: 'benefits', showEditBtnWhenEmpty: false})
                  Loading(v-if="editingPanel.ref === 'ref-benefits' && editingPanel.loading")
                  //- EDIT
                  div(v-if="editingPanel.ref === 'ref-benefits'")
                     //- Edit : Overview
                     ._mx1-5._mt075._mb1-5
                        ._mb075
                           label.InputLabel--connected._flexInline._flex-alignItemsCenter
                              SlideToggle(v-model="profileEditing.benefitsOverviewOn")
                              ._ml05._noSelect Overview?
                        div(v-if="profileEditing.benefitsOverviewOn")
                           .InputLabel-value Overview text
                           .Profile-qaItem._relative
                              EditorTipTap(v-model="profileEditing.benefitsOverview" :allowedActions="['bold', 'italic', 'link']")
                     //- Edit : New
                     ProfileEditNewItemBtn(noun='benefit' @onClick="profilePanelNew({type: 'benefit', items: profileEditing.benefits})")
                     //- Edit : List
                     SlickList.Profile-benefitItems._gridGap-0(
                        axis="xy" 
                        v-model="profileEditing.benefits"
                        helperClass="is-dragging"
                        @sort-start="onDragStart('benefits')"
                        @sort-end="onDragEnd"
                        @input="onDragSortFinish"
                     )
                        SlickItem.ProfileEdit-benefitsItem.ProfileEdit-benefitsItem--editView._whenDisabled-noEvents(
                           v-for="(benefit, index) in profileEditing.benefits" 
                           :index="index"
                           :key="benefit.optionKey"
                        )
                           ._relative.ProfileEdit-benefitsItem--editViewInner
                              //- Edit actions
                              .ProfileEdit-benefitsItemEditActions.BtnGroup
                                 button.Btn.Btn--inBtnGroup.Btn--xs.Btn--grey(@click="profilePanelEdit({type: 'benefit', itemIndex: index, item: benefit, items: profileEditing.benefits})") Edit
                                 button.Btn.Btn--inBtnGroup.Btn--xs.Btn--grey(@click="profileSectionChildDelete(index)") Remove
                              //- Edit display
                              +profileEdit-benefitListItem()
                  //- READ
                  div(v-else)
                     div(v-if="!profileDraft.benefits || !profileDraft.benefits.length")
                        ProfileEditNewItemBtn(noun='benefit' @onClick="profilePanelNew({type: 'benefit', items: profileDraft.benefits, parentPanelToEnter: 'ref-benefits', initialUI: true})")
                     +profileShared-benefits({context: 'vue', profileObj: profileDraft})(v-else @dblclick="profileSectionEditEnter({ref: 'ref-benefits'})")
</template>

<style lang="sass" scoped>
.Icon--help
   .primary
      fill: $green-100
   .secondary
      fill: $green-700
.EditIconWrap svg
   display: inherit
   .primary
      fill: $grey-900
   .secondary
      fill: $light-blue-vivid-800
.EditIconWrap--xs svg
   +wh(14px)

.Profile-sectionWrap,
.Profile-sectionInner
   &.is-editingPanel
      border-color: $light-blue-vivid-700
      box-shadow: 0 0 0 4px rgba($light-blue-vivid-600,0.15)

.ProfileEdit-openingsItem--editView
   cursor: ns-resize
   &.is-dragging
      +boxShadow--2
   &:last-of-type
      border-bottom: none
   &:last-of-type
      border-bottom-left-radius: $radius
      border-bottom-right-radius: $radius
.ProfileEdit-openingsItemEditActions
   text-align: center
   position: absolute
   +lr(0)
   top: -15px
   width: 100%
   +px($s-05)
   display: none
   .ProfileEdit-openingsItem--editView:hover &
      display: block
   .is-childBeingDragged &
      display: none !important
.is-childBeingDragged
   cursor: ns-resize
   .ProfileEdit-openingsItem
      +boxShadow
.Profile-openingListItem
   &.Profile-openingListItem--editMode
      cursor: inherit
      &:hover,
      &:focus
         border-color: $grey-100
.Profile-openingListItemActionIcon
   .Profile-openingListItem--editMode:hover &,
   .Profile-openingListItem--editMode:focus &
      opacity: 0.5


.ProfileEdit-benefitsItem--editView
   padding: $s-05
.ProfileEdit-benefitsItem--editViewInner
   padding: $s-1
   height: 100%
   cursor: ns-resize
   border-radius: $radius
   &:hover
      background-color: $light-blue-vivid-050
      .ProfileEdit-benefitsItemEditActions
         display: block
   .is-childBeingDragged &
      background-color: transparent
      .ProfileEdit-benefitsItemEditActions
         display: none
.ProfileEdit-benefitsItem--editView.is-dragging
   .ProfileEdit-benefitsItem--editViewInner
      background-color: white
      cursor: ns-resize
      +boxShadow--2
      left: -10px
      right: -10px
      top: -10px
      bottom: -10px
      padding: 10px
      border-radius: $radius
.ProfileEdit-benefitsItemEditActions
   text-align: center
   position: absolute
   +lr(0)
   top: -16px
   width: 100%
   +px($s-05)
   display: none
.is-childBeingDragged .ProfileEdit-benefitsItem
   opacity: 0.4

.PanelChangeCount
   position: absolute
   right: $s-1-5
   bottom: 100%
   background-color: $yellow-vivid-400
   color: $yellow-vivid-900
   border-top-left-radius: $radius
   border-top-right-radius: $radius
   +px($s-05)
   line-height: 1
   padding-top: 5px
   z-index: 0
   padding-bottom: 3px

.PublishUi
   position: fixed
   bottom: $s-1
   right: $s-1
   z-index: 100
.PublishUi-saveIcon svg
   +absoluteCenterXY
   width: 90%
   height: 90%
   .primary
      fill: $green-100
   .secondary
      fill: $green-700

.ProfileEdit-dynamicsSideUi
   position: absolute
   right: 100%
   margin-right: $s-1
   top: 61px // height of section heading bar
.ProfileEdit-dynamicsSideUi-itemActionBtns
   +absoluteCenterY
   left: -16px
   display: none
   .ProfileEdit-dynamicsSideUi-item:hover &
      display: block

.ProfileEdit-answerQuestionButton
   border: dashed 1px transparent
   cursor: pointer
   &:hover:not([disabled])
      border-color: $light-blue-vivid-700
   &:disabled
      cursor: default
   .is-childBeingDragged &
      cursor: unset
      &:hover
         border-color: transparent
</style>

<script>
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
import { SlickList, SlickItem } from 'vue-slicksort'
import { getRandomId, createImagePath } from '~/util'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import slugify from '@sindresorhus/slugify'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import Gumshoe from 'gumshoejs'
// Data files
import dataCountriesByContinent from '~/../../s-dataStatic/countries-by-continent.json'
import timezonesUTC from '~/../../s-dataStatic/timezonesUTC.json'
// Data files - attrs
import attrsRemote from '~/../../s-dataStatic/attrs-remote.yaml'
import attrsBenefits from '~/../../s-dataStatic/attrs-benefits.yaml'
import attrsExperienceLevel from '~/../../s-dataStatic/attrs-openingExperienceLevel.yaml'
import qaPrimary from '~/../../s-dataStatic/attrs-qaPrimary.yaml'
import attrsPositionRole from '~/../../s-dataStatic/attrs-openingJobRole.yaml'
import attrsOpeningNextStepCTA from '~/../../s-dataStatic/attrs-openingNextStepCTA.yaml'
import attrsOpeningJobType from '~/../../s-dataStatic/attrs-openingJobType.yaml'
import attrsJobTech from '~/../../s-dataStatic/attrs-openingJobTech.yaml'
import attrsLocation from '~/../../s-dataStatic/attrs-location.yaml'
import attrsTimezone from '~/../../s-dataStatic/attrs-timezone.yaml'
// Components
import ProfileEditNewItemBtn from '~/components/ProfileEditNewItemBtn'
import SlideToggle from '~/components/SlideToggle'
import customVSelectDeselectTag from '~/components/customVSelectDeselectTag'
import Panel from '~/components/profileEdit-Panel'
import JobViewer from '~/components/JobViewer'
import EditorTipTap from '~/components/EditorTipTap'
import InputArray from '~/components/InputArray'
import InputSelect from '~/components/InputSelect'
//
import uploadFileToStorage from '~/lib/upload-sendFileToStorage'
import getImageUploadAsFile from '~/lib/upload-getImageAsFile'

const setOrderSeqsToIndexes = items => items.forEach((item, index) => (item.orderSeq = index))

const newOpeningPrototype = {
   id: null, // assigned when created
   heading: null,
   jobType: {},
   primaryRoles: [],
   experienceLevel: [],
   tech: [],
   descriptionType: null, // `onSite`, `external`
   descriptionExternalUrl: null,
   onSiteDescription: null,
   // nextStepCTA: { optionKey: 'apply' },
   // nextStepURL: null,
   orderSeq: null,
   salaryInfo: {},
   workFromLocation: {},
   workOnTimezone: {}
}

const newBenefitPrototype = {
   optionKey: null,
   description: null,
   orderSeq: null,
}

function createPrimaryQa(attr, index) {
   return {
      attrKey: attr.attrKey,
      optionKey: attr.optionKey,
      orderSeq: index,
      description: null
   }
}

const qaPrimarySlideoutStatePrototype = {
   step: 1,
   adding: null,
}

function mapCountriesByContinentToCountries() {
   const countries = dataCountriesByContinent.map(item => item.children)
   const countriesFlat = [].concat.apply([], countries)
   return countriesFlat
}

export default {
   components: {
      SlickList,
      SlickItem,
      EditorTipTap,
      Treeselect,
      InputArray,
      InputSelect,
      vSelect,
      customVSelectDeselectTag,
      ProfileEditNewItemBtn,
      SlideToggle,
      Panel,
      JobViewer,
   },
   metaInfo: {
      link: [
         { rel: 'stylesheet', href: 'https://unpkg.com/vue-select@latest/dist/vue-select.css' },
         { rel: 'stylesheet', href: 'https://cdn.jsdelivr.net/npm/@riophae/vue-treeselect@0.4.0/dist/vue-treeselect.min.css' },
      ],
   },
   staticData() {
      // This is purely a read-only array of objects so there's no need to have it be "reactive", which
      // it would be if it was stored on the `data` object (the thinking here is that this keeps the memory usage lower... need to look further into this)
      return {
         countries: mapCountriesByContinentToCountries(),
         countriesByContinent: dataCountriesByContinent,
         // TODO: Consider renaming this to something like `srcAttrs` (to help clarify that this comes from
         // the source/template/prototype files (the local files used for normalizing this data while keeping
         // it flexible in terms of the displayed names)).
         attrs: {
            remoteDegree: attrsRemote,
            qaPrimary: qaPrimary,
            benefits: attrsBenefits,
            experienceLevel: attrsExperienceLevel,
            primaryRoles: attrsPositionRole,
            openingNextStepCTA: attrsOpeningNextStepCTA,
            openingJobType: attrsOpeningJobType,
            jobTech: attrsJobTech,
            location: attrsLocation,
            timezone: attrsTimezone,
         },
      }
   },
   data() {
      return {
         // -------------------------------
         // edit panel
         Panel: Panel,
         showPanel: false,
         panelProps: undefined,
         // -------------------------------
         Deselect: customVSelectDeselectTag,
         teamSrc: null,
         profileSrc: null,
         teamProfileSlug: this.$route.params.companySlug + '/' + this.$route.params.teamSlug,
         team: null,
         isLoaded: false,
         // CONSIDER (organizing the state like this)
         // Three layers of state
         // 1. profileTruth (above, `profile`)
         // 2. profileEdited
         // 3. profileEditing
         profileDraft: {},
         profileEditing: {},
         newOpening: null,
         editingPanel: {
            loading: false,
            ref: null,
            disableExit: false,
            editingChildRef: null,
            editedChildCount: 0,
         },
         qaPrimarySlideoutState: null,
         isDragging: null, // string
         showingInitialUI: false,
         dataWorkFromLocation: dataCountriesByContinent,
         isSavingDraft: false,
         isPublishing: false,
         dropZoneActive: false,
         timezonesUTC,
         editingItemIndex: null,
         rootLevelImageUploadUiRef: null,
         imageUploadUiHeading: null,
         imageUploadUiHelpText: null,
         isJobViewerOpen: false,
         isJobViewerInPreviewMode: null,
         isJobViewerInPreviewMode: false
      }
   },
   computed: {
      ...mapState(['makerState']),
      editingPanelHasUnsavedEdits: function() {
         return this.editingPanel.editedChildCount !== 0
      },
      profileHasUnpublishedEdits: function() {
         return this.profileDraft.state === 'draft'
      },
      // benefitsNotSet: function() {
      //    const setBenefitOptionKeys = this.profileEditing.benefits && this.profileEditing.benefits.map(item => item.optionKey)
      //    return attrsBenefits.filter(attr => !setBenefitOptionKeys.includes(attr.optionKey))
      // },
   },
   methods: {
      profileSectionEditEnter({ref, childIndex}) {
         if (!ref) return

         // Do not allow toggling between panels (must first explictly exit edit mode)
         if (this.editingPanel.ref) return

         this.editingPanel.ref = ref
         this.dropZoneActive = false

         // Set initial draft data
         // Note: If needing properties in `profileEditing` to be reactive (in the case of the team count UI where there's a toggle button to change whether
         // to use a range), the property needs to be set like below. Also, it's important to use a cloned copy of the `profileDraft[attr]`, otherwise canceling
         // out of the panel doesn't reset any changed values.
         switch (ref) {
            case 'ref-openings':
               this.$set(this.profileEditing, 'openings', cloneDeep(this.profileDraft.openings))
               break
            case 'ref-benefits':
               this.$set(this.profileEditing, 'benefits', cloneDeep(this.profileDraft.benefits))
               this.$set(this.profileEditing, 'benefitsOverview', cloneDeep(this.profileDraft.benefitsOverview))
               this.$set(this.profileEditing, 'benefitsOverviewOn', cloneDeep(this.profileDraft.benefitsOverviewOn))
               break
            case 'ref-overview':
               this.$set(this.profileEditing, 'summary', cloneDeep(this.profileDraft.summary))
               this.$set(this.profileEditing, 'imageLogo', cloneDeep(this.profileDraft.imageLogo))
               this.$set(this.profileEditing, 'remoteDegree', cloneDeep(this.profileDraft.remoteDegree))
               this.$set(this.profileEditing, 'teamSize', cloneDeep(this.profileDraft.teamSize))
               this.$set(this.profileEditing, 'companySize', cloneDeep(this.profileDraft.companySize))
               this.$set(this.profileEditing, 'website', cloneDeep(this.profileDraft.website))
               this.$set(this.profileEditing, 'workFromLocation', cloneDeep(this.profileDraft.workFromLocation))
               this.$set(this.profileEditing, 'workOnTimezone', cloneDeep(this.profileDraft.workOnTimezone))
               // Directly open the edit panel
               this.profilePanelEdit({ type: 'overview', items: this.profileEditing, directlyEditProfileEditObj: true })
               break
            case 'ref-qaPrimary':
               this.$set(this.profileEditing, 'qaPrimary', cloneDeep(this.profileDraft.qaPrimary))
               // Directly open the edit panel
               this.profilePanelAnswerOrEditQuestion({isNew: false, itemIndex: childIndex, type: 'qaPrimary', item: this.profileEditing.qaPrimary[childIndex], items: this.profileEditing.qaPrimary, parentPanelToEnter: 'ref-qaPrimary'})
               break
         }
      },
      profileSectionEditCancel(ref) {
         this.editingPanel.editedChildCount = 0
         this.editingPanel.ref = null
         switch (ref) {
            case 'ref-openings':
               this.profileEditing.openings = []
               break
            case 'ref-benefits':
               this.profileEditing.benefits = []
               break
            case 'ref-overview':
               this.profileEditing.summary = null
               this.profileEditing.remoteDegree = null
               this.profileEditing.teamSize = null
               this.profileEditing.companySize = null
               this.profileEditing.website = null
               this.profileEditing.workFromLocation = null
               this.profileEditing.workOnTimezone = null
               break
            case 'ref-qaPrimary':
               this.profileEditing.qaPrimary = null
               break
         }
      },
      profileSectionEditDone(ref) {
         this.isSavingDraft = true
         this.editingPanel.loading = true
         this.editingPanel.editedChildCount = 0

         let updatePromises = []
         let updateData
         let logoOrHeroImageUploadPromise

         switch (ref) {
            case 'ref-openings':
               updateData = { openings: cloneDeep(this.profileEditing.openings) }
               break
            case 'ref-benefits':
               updateData = { 
                  benefits: cloneDeep(this.profileEditing.benefits),
                  benefitsOverviewOn: cloneDeep(this.profileEditing.benefitsOverviewOn),
                  benefitsOverview: cloneDeep(this.profileEditing.benefitsOverview)
               }
               break
            case 'ref-overview':
               updateData = {
                  summary: cloneDeep(this.profileEditing.summary),
                  remoteDegree: cloneDeep(this.profileEditing.remoteDegree),
                  teamSize: cloneDeep(this.profileEditing.teamSize),
                  companySize: cloneDeep(this.profileEditing.companySize),
                  website: cloneDeep(this.profileEditing.website),
                  workFromLocation: cloneDeep(this.profileEditing.workFromLocation),
                  workOnTimezone: cloneDeep(this.profileEditing.workOnTimezone),
               }
               if (this.profileEditing.imageLogo.file) {
                  updateData.imageLogo = {
                     src: this.profileEditing.imageLogo.file.nameWithHash,
                  }
                  logoOrHeroImageUploadPromise = uploadFileToStorage(this.profileEditing.imageLogo.file)
               }
               break
            case 'ref-imageHero':
               updateData = {
                  imageHero: { src: this.profileEditing.imageHero.file.nameWithHash }
               }
               logoOrHeroImageUploadPromise = uploadFileToStorage(this.profileEditing.imageHero.file)
               break
            case 'ref-imageLogo':
               updateData = {
                  imageLogo: { src: this.profileEditing.imageLogo.file.nameWithHash }
               }
               logoOrHeroImageUploadPromise = uploadFileToStorage(this.profileEditing.imageLogo.file)
               break
            case 'ref-qaPrimary':
               updateData = {
                  qaPrimary: this.profileEditing.qaPrimary.filter(item => item.description) // Only store questions that have descriptions (i.e. prevent unfinished ones from getting stored).
               }
               break
         }

         updateData.state = 'draft'

         updatePromises.push(
            this.$store.dispatch('updateProfileDraft', {
               teamRef: this.teamSrc.ref,
               profileRef: this.profileSrc.ref,
               profileWithUpdatedData: updateData,
            }),
         )

         if (logoOrHeroImageUploadPromise) {
            updatePromises.push(logoOrHeroImageUploadPromise)
         }

         return Promise.all(updatePromises)
            .then(resp => {
               const updatedProfile = resp[0]
               this.profileDraft = Object.assign({}, updatedProfile.data, updateData)
               this.initAnyUnsetQaPrimaryItems()
            })
            .finally(() => {
               this.isSavingDraft = false
               this.editingPanel.loading = false
               this.editingPanel.ref = null
               this.rootLevelImageUploadUiRef = null
            })
      },
      profileSectionChildDone(slug) {
         this.editingPanel.editingChildRef = null
         this.showingInitialUI = false
         this.editingPanel.disableExit = false
         this.editingPanel.editedChildCount += 1
         if (slug === 'newOpeningUI') {
            this.profileEditing.openings.unshift(this.newOpening)
            setOrderSeqsToIndexes(this.profileEditing.openings)
         } else if (slug === 'newBenefitUI') {
            this.profileEditing.benefits.unshift(this.newBenefit)
            setOrderSeqsToIndexes(this.profileEditing.benefits)
         }
      },
      profileSectionChildDelete(index) {
         if (this.editingPanel.ref === 'ref-openings') {
            this.profileEditing.openings.splice(index, 1)
            setOrderSeqsToIndexes(this.profileEditing.openings)
         } else if (this.editingPanel.ref === 'ref-benefits') {
            this.profileEditing.benefits.splice(index, 1)
            setOrderSeqsToIndexes(this.profileEditing.benefits)
         }
      },
      // --------------------------------------------
      // Item Panel New/Edit
      // --------------------------------------------
      profilePanelAnswerOrEditQuestion({isNew, type, itemIndex, item, items, parentPanelToEnter}) {
         if (isNew) {
            this.profileSectionEditEnter({ref: parentPanelToEnter})
         }
         this.editingItemIndex = itemIndex
         this.panelProps = { isNew, type, itemIndex, item: cloneDeep(item), items: cloneDeep(items) }
         this.showPanel = true
      },
      profilePanelNew({ type, items, parentPanelToEnter, initialUI }) {
         if (initialUI) {
            this.showingInitialUI = true
         }

         this.profileSectionEditEnter({ref: parentPanelToEnter})

         this.showPanel = true

         let item
         let clonedItems

         switch (type) {
            case 'dynamic':
               clonedItems = cloneDeep(items)
               break
            case 'benefit':
               item = cloneDeep(newBenefitPrototype)
               clonedItems = items.map(item => cloneDeep(item))
               break
            case 'opening':
               item = cloneDeep(newOpeningPrototype)
               item.id = getRandomId()
               clonedItems = items.map(item => cloneDeep(item))
               break
         }

         this.panelProps = { isNew: true, type, itemIndex: undefined, item, items: clonedItems }
      },
      profilePanelEdit({ type, itemIndex, item, items, directlyEditProfileEditObj }) {
         this.showPanel = true

         const clonedItem = cloneDeep(item)
         const itemsForPanel = directlyEditProfileEditObj ? items : items.map(item => cloneDeep(item))

         this.panelProps = { isNew: false, type, itemIndex, item: clonedItem, items: itemsForPanel }
      },
      profilePanelCancel({ type }) {
         this.showPanel = false
         switch (type) {
            case 'overview':
               this.profileSectionEditCancel('ref-overview')
               break
            case 'qaPrimary': 
               this.profileSectionEditCancel('ref-qaPrimary')
               break
         }
      },
      profilePanelDone({ isNew, type, itemIndex, item, items }) {
         this.showPanel = false

         if (isNew) {
            switch (type) {
               case 'benefit':
                  this.profileEditing.benefits.unshift(item)
                  setOrderSeqsToIndexes(this.profileEditing.benefits)
                  break
               case 'opening':
                  this.profileEditing.openings.unshift(item)
                  setOrderSeqsToIndexes(this.profileEditing.openings)
                  break
            }
         } else {
            switch (type) {
               case 'benefit':
                  this.profileEditing.benefits[itemIndex] = cloneDeep(item)
                  break
               case 'opening':
                  this.profileEditing.openings[itemIndex] = cloneDeep(item)
                  break
            }
         }

         // For types that don't really make use of the `profileEditing` middleman
         switch (type) {
            case 'overview':
               this.profileEditing = items
               this.profileSectionEditDone('ref-overview')
               break
            case 'qaPrimary':
               this.profileEditing.qaPrimary[itemIndex] = cloneDeep(item)
               this.profileSectionEditDone('ref-qaPrimary')
               break
         }
      },
      // --------------------------------------------
      onDragStart(currentContainerString) {
         this.isDragging = currentContainerString
      },
      onDragEnd() {
         this.isDragging = null
      },
      onDragSortFinish(items) {
         // The d&d library we're using does not yet support
         // ordering by a specific property...
         // https://github.com/Jexordexan/vue-slicksort/issues/83
         // Thus, we need to explicitly update it once the sort has finished.
         setOrderSeqsToIndexes(items)
         this.profileSectionChildDone() // needed to update the edited state on d&d finish.
      },
      // resetAllProfileEdits() {
      //    // TODO: Handle actually resetting the data here...
      //    // Also: Consider how to prevent manually setting the values here to 0
      //    this.profileDraft = cloneDeep(this.profileSrc)
      //    for (var ref in this.panelState) {
      //       this.panelState[ref].editedCount = 0
      //    }
      // },
      resetAllSectionEdits(ref) {
         switch (ref) {
            case 'ref-openings': 
               this.profileDraft.openings = cloneDeep(this.profile.openings)
               break
            case 'ref-benefits':
               this.profileDraft.benefits = cloneDeep(this.profile.benefits)
               break
            case 'ref-overview':
               this.profileDraft.summary = cloneDeep(this.profile.summary)
               break
            case 'ref-overview':
               this.profileDraft.remoteDegree = cloneDeep(this.profile.remoteDegree)
               this.profileDraft.teamSize = cloneDeep(this.profile.teamSize)
               this.profileDraft.companySize = cloneDeep(this.profile.companySize)
               this.profileDraft.website = cloneDeep(this.profile.website)
               break
            case 'ref-qaPrimary':
               this.profileDraft.qaPrimary = cloneDeep(this.profile.dynamics)
               break
            case 'ref-locationAndTimezone':
               this.profileDraft.workFromLocation = cloneDeep(this.profile.workFromLocation)
               this.profileDraft.workOnTimezone = cloneDeep(this.profile.workOnTimezone)
               break
         }
      },
      maybeFocusRangeMaxOnToggle() {
         this.$nextTick(() => this.$refs.jsFocusTargetOnChangeToRangeTrue && this.$refs.jsFocusTargetOnChangeToRangeTrue.focus())
      },
      // ----------------------------------------------------
      // Image upload UI (root images, not TipTap editor)
      // ----------------------------------------------------
      rootLevelImageUploadUiShow({ref, heading, helpText}) {
         disableBodyScroll(this.$refs.underlayForImageUploadUi, {
            reserveScrollBarGap: true,
         })
         this.rootLevelImageUploadUiRef = ref
         this.imageUploadUiHeading = heading
         this.imageUploadUiHelpText = helpText

         this.dropZoneActive = false
         
         if (ref === 'ref-imageHero') {
            this.profileEditing.imageHero = cloneDeep(this.profileDraft.imageHero)
         } else if (ref === 'ref-imageLogo') {
            this.profileEditing.imageLogo = cloneDeep(this.profileDraft.imageLogo)
         } 
      },
      rootLevelImageOnUpload(event) {
         const handleFileChange = (editingAttr) => {
            const file = getImageUploadAsFile(event, this.teamSrc.ref.id)

            this.profileEditing[editingAttr].file = file

            // After the user uploads an image we store the object URL version of it in the `src` property.
            // When retrived from the DB, the `src` property value is the file's path inside of digital ocean (teamId/fileName.extension)
            this.profileEditing[editingAttr].src = window.URL.createObjectURL(file)

            this.profileSectionChildDone(editingAttr)

            clearAllBodyScrollLocks()
         }
         
         switch (this.rootLevelImageUploadUiRef) {
            case 'ref-imageHero':
               handleFileChange('imageHero')
               break
            case 'ref-imageLogo':
               handleFileChange('imageLogo')
               break
         }

         this.profileSectionEditDone(this.rootLevelImageUploadUiRef)
      },
      cancelRootLevelImageUploadUi() {
         clearAllBodyScrollLocks()
         this.rootLevelImageUploadUiRef = null
      },
      // ----------------------------------------------------
      publishEdits() {
         this.isPublishing = true
         this.profileDraft.state = 'published'

         return this.$store
            .dispatch('publishProfile', {
               teamRef: this.teamSrc.ref,
               profileRef: this.profileSrc.ref,
               profileWithUpdatedData: this.profileDraft,
               isFirstPublish: !this.profileDraft.firstPublishTs
            })
            .then(() => {
               this.$snotify.success('Profile changes published. Please allow 1 - 2 minutes for changes to go live.')
            })
            .finally(() => {
               this.isPublishing = false
            })
         // TODO: Hit Nelify functions endpoint that will POST (I think) a value to KV store (keyed on path). On loading of the profile, if the route path exists, use
         // the HTML rewriter API to load the updated profile. On deploy, clear all of these items from the KV store.
      },
      // ----------------------------------------------------
      // Job description
      // ----------------------------------------------------
      showJobViewerHandler({overrideId, isPreviewMode, overrideOpening} = {}) {
         const openingId = overrideId || this.$route.query.openingId
         if (!openingId) return

         let opening = overrideOpening
         if (!opening) {
            const openingInEdit = this.profileEditing && this.profileEditing.openings && this.profileEditing.openings.find(opening => opening.id === openingId)
            const openingDraft = this.profileDraft.openings && this.profileDraft.openings.find(opening => opening.id === openingId)
            opening = openingInEdit ? openingInEdit : openingDraft
         }

         if (!opening) {
            this.$router.replace({ path: this.$router.currentRoute.path })
            return
         }

         this.isJobViewerInPreviewMode = isPreviewMode
         this.jobViewerOpening = opening
         this.isJobViewerOpen = true
      },
      jobViewerPreviewClose() {
         this.isJobViewerOpen = false
      },
      // ----------------------------------------------------
      // Init helpers
      // ----------------------------------------------------
      initAnyUnsetQaPrimaryItems() {
         const alreadySetQaPrimaryKeys = this.profileDraft.qaPrimary && this.profileDraft.qaPrimary.map(item => item.attrKey)
         if (alreadySetQaPrimaryKeys.length === this.attrs.qaPrimary.length) {
            return
         }

         const notSet = this.attrs.qaPrimary.filter(attr => {
            return !alreadySetQaPrimaryKeys.includes(attr.attrKey)
         })
         notSet.forEach((item) => {
            const indexToSet = this.attrs.qaPrimary.indexOf(item)
            this.profileDraft.qaPrimary.splice(indexToSet, 0, createPrimaryQa(item, indexToSet))
         }) 
      }
   },
   mounted() {
      console.log('mounted!')
      const teamProfile = this.makerState.teamProfiles.find(teamProfile => teamProfile.data.slug.current === this.teamProfileSlug)
      this.profileSrc = teamProfile
      this.teamSrc = teamProfile.teamResolved
      this.profileDraft = cloneDeep(teamProfile.data)
      this.initAnyUnsetQaPrimaryItems()
      this.isLoaded = true
      this.showJobViewerHandler()
   },
}
</script>
